import { PropsWithChildren } from 'react';
import IconFont from './IconFont';

interface IconProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  type: string;
  disabled?: boolean;
}

const Icon:React.FC<IconProps & PropsWithChildren> = props => {
  return (
    <span className={`uni-icon ${props.disabled ? 'disabled' : ''}`} {...props}>
      <IconFont type={props.type.includes('icon-') ? props.type : 'icon-' + props.type} />
      <span>{props.children}</span>
    </span>
  );
};

export default Icon;